<template>
	<div class="modal" v-show="showDialog">
		<div class="modal-wrapper">
			<div class="modal-overlay"></div>
			<div class="modal-container">
				<div class="modal-header">
					<div class="modal-header__title">
						<span>{{$t('Update schedule')}}</span>
					</div>
					<div class="modal-header__close" @click="hideScheduleDialog">
						<SvgIcon
							width="16"
							height="16"
							:iconType="'slim'"
						/>
					</div>
				</div>
				<div class="modal-body">
					<div class="leaderboard__schedule">
						<form class="leaderboard__schedule-form">
							<div
								class="leaderboard__schedule-form-item"
								v-for="(round, index) in timings"
								:class="{disabled: 'CLOSED' === round.status.toUpperCase()}"
							>
								<div class="form-group__item">
									<div class="leaderboard__schedule-form-label">{{$t('Title')}}</div>
									<div class="leaderboard__schedule-form-round">{{$t('Round')}} {{round.round}}
                                    <template v-if="round.lobby">(Lobby {{ round.lobby }})</template>
                                    </div>
								</div>
								<div class="form-group__item">
									<div class="leaderboard__schedule-form-label">{{$t('Start time')}}</div>
									<div class="leaderboard__schedule-form-input">
										<Datetime
											type="datetime"
											v-model="timings[index].started_at"
										/>
									</div>
								</div>
							</div>
							<div class="leaderboard__schedule-form-footer">
								<button
									class="button button-primary"
									@click.prevent="save()"
								>{{$t('Save')}}
								</button>
							</div>
						</form>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import {mapActions, mapGetters} from 'vuex'
	import moment from 'moment'
	import {Datetime} from 'vue-datetime'

	import SvgIcon from '../../components/SvgIcon'
	import helpers from '../../helpers'

	export default {
		name: "LeaderboardRoundsScheduleDialog",
		components: {
			SvgIcon,
			Datetime
		},
		computed: {
			...mapGetters({
				tournament: 'tournament',
				showDialog: 'scheduleLeaderBoardDialogState',
				timings: 'scheduleLeaderBoardDialogData',
			})
		},
		data() {
			return {
				minTimeDiff: 5,
				maxTimeDiff: 120,
			};
		},
		watch: {
			timings: {
				handler: function () {
					this.updateTimings();
				},
				deep: true
			},
		},
		methods: {
			...mapActions({
				hideScheduleDialog: 'hideLeaderBoardScheduleDialog',
				saveSchedule: 'saveLeaderBoardSchedule',
			}),
			save() {
				let data = [];
				const lastRoundIndex = this.timings.length - 1;

				this.timings.forEach((item, index) => {
					// const roundIsOpened = 'OPENED' === item.status.toUpperCase();
					const roundStartTime = helpers.prepareDateTimeToSave(item.started_at);
					const currentRoundStartTime = item.started_at;

					let duration = null;

					// if (!roundIsOpened) return;

					if (index === lastRoundIndex) {
						duration = this.maxTimeDiff;
					} else {
						const nextRoundStartTime = this.timings[index + 1].started_at;
						duration = helpers.getTimeDiff(nextRoundStartTime, currentRoundStartTime);
					}

					// if (this.maxTimeDiff < duration) duration = this.maxTimeDiff;

					data.push({
						round: item.round,
						duration: duration,
                        lobby: item.lobby,
						started_at: roundStartTime
					})
				});

				this.saveSchedule({
					id: this.tournament.getId(),
					body: data
				});
			},
			updateTimings() {
				for (let i = 1; i < this.timings.length; i++) {
					const currentRoundStartTime = this.timings[i].started_at;
					const previousRoundStartTime = this.timings[i - 1].started_at;
					const currentAndPreviousTimeDiff = helpers.getTimeDiff(currentRoundStartTime, previousRoundStartTime);

					if (this.minTimeDiff > currentAndPreviousTimeDiff) {
						this.timings[i].started_at = moment(previousRoundStartTime).utc().add(this.minTimeDiff, 'minutes').format();
					}
				}
			}
		}
	};
</script>
